import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookie'
import Home from './pages/home.vue'
import Login from './pages/login.vue'
import not_fund from './pages/404not_fund.vue'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home,
      redirect: '/enterOrder',
      children: [{
        path: '/enterOrder/:order_id?/:client_data_type?/:ifFinish?',
        name: 'enterOrder',
        component: () => import(/* webpackChunkName: "about" */ './pages/home_subpages/enterOrder.vue'),
        props: true
      },
      {
        path: '/myOrder',
        name: 'myOrder',
        component: () => import(/* webpackChunkName: "about" */ './pages/home_subpages/myOrder.vue')
      }]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }, {
      path: '/',
      redirect: () => {
        return '/home'
      }
    },
    {
      path: '*',
      name: 'not_fund',
      component: not_fund
    }
  ]
})
router.beforeEach((to, from, next) => {
  let isLogin = VueCookies.get('is_login');
  if (isLogin || to.name == 'login' || to.name == 'not_fund') {

    
    next()
    return
  }
  next('/login');
})
export default router